export const safelyGetNavigator = (): typeof navigator => (typeof navigator !== 'undefined' ? navigator : undefined)
